module.exports = __webpack_public_path__ + "static/media/tada_driver_codes_zh-TW_HK.eb2fcdf5.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_driver_codes_zh-TW_HK.md
// module id = 73
// module chunks = 0